export default __webpack_public_path__ + "static/media/arrow-right-topbar.494fb252.svg";